// extracted by mini-css-extract-plugin
export var bodySections = "_de-8";
export var gray = "_de-7";
export var green = "_de-4";
export var iconContainer = "_de-9";
export var iconWidgetContainer = "_de-1";
export var phoneIcon = "_de-2";
export var red = "_de-5";
export var statusDot = "_de-3";
export var widgetContainer = "_de-0";
export var yellow = "_de-6";